module.exports = {
      id: "search-usage",
      viewBox: "0 0 512 512",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#search",
      toString: function () {
        return this.url;
      }
    }